import { useState } from "react";
import { toast } from "sonner";
import { Chip } from "@/components/common";
import { Input } from "@/components/ui/input";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";

const STATUS = {
  actif: ["Actif", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  inactif: ["Inactif", "bg-slate-100 text-slate-600 border-slate-300"],
  archive: ["Archivé", "bg-violet-50 text-violet-700 border-violet-200"],
  supprime: ["Supprimé", "bg-rose-50 text-rose-700 border-rose-200"],
};

export const StatusChip = ({ u }) => {
  const s = STATUS[u.status || (u.active ? "actif" : "inactif")];
  return <Chip cls={s[1]} testid={`user-status-${u.id}`}>{s[0]}</Chip>;
};

const TEXT = {
  archive: ["Archiver ce compte ?", "Le compte ne pourra plus se connecter et sera libéré de ses véhicules. Tout l'historique (contrôles, anomalies, relevés, entretiens, dépenses) est conservé et reste affiché avec son nom. Le compte peut être restauré.", "Archiver"],
  restore: ["Restaurer ce compte ?", "Le compte repasse en statut Inactif : vous pourrez ensuite le réactiver depuis la modification.", "Restaurer"],
  delete: ["Suppression définitive", "Les identifiants (email, mot de passe) sont supprimés définitivement et le compte ne pourra plus être restauré. L'historique métier est conservé et affiché sous son nom. Pour un salarié qui quitte l'entreprise, préférez l'archivage. Saisissez l'email exact du compte pour confirmer.", "Supprimer définitivement"],
};

export function LifecycleDialog({ action, u, onClose, onDone }) {
  const [typed, setTyped] = useState("");
  const [title, desc, label] = TEXT[action];
  const run = async () => {
    try {
      if (action === "delete") await api.delete(`/users/${u.id}`, { params: { confirm: typed } });
      else await api.post(`/users/${u.id}/${action}`);
      toast.success(action === "archive" ? "Compte archivé" : action === "restore" ? "Compte restauré" : "Compte supprimé");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <AlertDialog open onOpenChange={onClose}>
      <AlertDialogContent data-testid={`user-${action}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title} — {u.name}</AlertDialogTitle>
          <AlertDialogDescription>{desc}</AlertDialogDescription>
        </AlertDialogHeader>
        {action === "delete" && <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={u.email || u.name} data-testid="user-delete-confirm-input" />}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid={`user-${action}-cancel`}>Annuler</AlertDialogCancel>
          <AlertDialogAction onClick={run} disabled={action === "delete" && typed.trim().toLowerCase() !== (u.email || u.name).toLowerCase()}
            className={action === "delete" ? "bg-rose-600 hover:bg-rose-700" : "bg-[#0E2D43]"} data-testid={`user-${action}-confirm`}>{label}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function ArchiveDemoButton({ count, onDone }) {
  const [open, setOpen] = useState(false);
  if (!count) return null;
  const run = async () => {
    try {
      const { data } = await api.post("/users/archive-demo");
      toast.success(`${data.archived} compte(s) DÉMO archivé(s)`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className="inline-flex items-center gap-2 h-10 px-4 rounded-md border border-violet-300 text-violet-700 text-sm font-semibold hover:bg-violet-50" data-testid="archive-demo-users-button">
        Archiver les {count} comptes DÉMO
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="archive-demo-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Archiver tous les comptes DÉMO ?</AlertDialogTitle>
            <AlertDialogDescription>{count} comptes de démonstration ne pourront plus se connecter. Leur historique est conservé.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="archive-demo-cancel">Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={run} className="bg-[#0E2D43]" data-testid="archive-demo-confirm">Archiver</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
